import { IconType } from 'react-icons';
import MenuDesktopItem from '@components/ui/MenuDesktopItem/MenuDesktopItem';
import './MenuDesktop.scss';

type MenuDesktopItemType = {
    label: string,
    icon: IconType,
    to: string,
    active?: boolean,
    disabled?: boolean,
};

type MenuDesktopProps = {
    items: Array<MenuDesktopItemType>,
};

function MenuDesktop(props: MenuDesktopProps) {

    return (
        <nav className="menu-desktop">
            {props.items.map((item: MenuDesktopItemType, index: number) => (
                <MenuDesktopItem key={index} label={item.label} icon={item.icon} to={item.to} active={item.active} disabled={item.disabled}/>
            ))}
        </nav>
    );
}

export default MenuDesktop;
